import { AppendBody } from "@/common/append-body";
import { cn } from "@/utils/cn";
import { defined } from "@/utils/variable-evaluation";
import React from "react";

interface IOverlayMessengerConfig {
  width: number;
}

export const FullscreenOverlay = React.memo(function FullscreenOverlay(props: {
  id?: string;
  messengerConfig?: IOverlayMessengerConfig;
  isTransparent?: boolean;
  isLanding?: boolean;
  inlineStyle?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  const isMessenger = () => defined(props.messengerConfig);

  const { isTransparent, children, inlineStyle, id } = props;
  return (
    <AppendBody>
      <div
        id={id}
        className={cn("min-h-screen w-full overflow-hidden", {
          // One shared popup layer: every overlay sits at the same z-index
          // (above the header and the call screen), so a popup opened later
          // lands on top by DOM order - no per-popup z-index needed.
          "fixed top-0 left-0 z-12": !isMessenger(),
          "absolute top-0 left-0 z-5": isMessenger(),
          "min-h-auto tablet:top-header-height tablet:right-0 tablet:left-80 tablet:z-5 tablet:h-[calc(100%-50px)] tablet:min-h-auto tablet:w-[calc(100%-320px)] tablet:transform-none tablet:overflow-visible":
            isMessenger(),
          "bg-transparent": isTransparent,
        })}
        style={defined(inlineStyle) ? inlineStyle : {}}
      >
        {children}
      </div>
    </AppendBody>
  );
});
